<template>
  <div class="login-box">
    <div class="left-box">
      <Carousel
        autoplay
        v-model="carouselIndex"
        loop
        arrow="never"
        radius-dot
        :autoplay-speed="3000"
      >
        <CarouselItem>
          <a target="_blank" href="https://aidprint.com/product_aidprint">
            <div class="car-item">
              <img class="img" src="../../assets/ic_aidprint.png" />
              <div class="title">
                <img
                  style="width: 40px; height: 40px; margin-right: 15px"
                  src="../../assets/ic_banner1.png"
                />
                通用基础版
              </div>
              <div class="des">满足全场景自助共享文印的全能型选手</div>
            </div>
          </a>
        </CarouselItem>
        <CarouselItem>
          <a target="_blank" href="https://aidprint.com/product_custprint">
            <div class="car-item">
              <img class="img" src="../../assets/ic_custprint.png" />
              <div class="title">
                <img
                  style="width: 40px; height: 40px; margin-right: 15px"
                  src="../../assets/ic_banner2.png"
                />
                服务窗口版
              </div>
              <div class="des">用心为特定场景和使用人群而打造</div>
            </div>
          </a>
        </CarouselItem>
        <CarouselItem>
          <a target="_blank" href="https://aidprint.com/product_ops">
            <div class="car-item">
              <img class="img" src="../../assets/ic_product_ops.png" />
              <div class="title">
                <img
                  style="width: 40px; height: 40px; margin-right: 15px"
                  src="../../assets/ic_banner3.png"
                />
                智能运维
              </div>
              <div class="des">设备远程运维管理和服务流程的好帮手</div>
            </div>
          </a>
        </CarouselItem>
      </Carousel>
    </div>
    <div class="login-content">
      <div class="header">
        <a href="https://www.aidprint.com" target="_blank">
          <img src="../../assets/logo.png" alt class="logo" />
        </a>
        <div class="switch-lang">
          <switch-lang></switch-lang>
        </div>
      </div>
      <!-- 密码登录 -->
      <div class="login-box-dis">
        <div class="login-box-from">
          <div class="login-box-title">{{ words.AccountpasswordloginWechat }}</div>
          <div class="from-box">
            <div class="qrcode login-code" id="qrcode"></div>
            <div class="qrcode-tips">
              <p class="txt">{{words.OpenWeChatandscan}}</p>
              <p class="txt">{{words.Automaticallyregisterlogintopersonalmembershipaccount}}</p>
            </div>
          </div>
        </div>
        <div class="login-box-from">
          <div class="login-box-title">{{ words.Accountpasswordlogin }}</div>
          <div class="from-box">
            <div class="item">
              <input
                type="text"
                :placeholder="words.Pleaseenterthephonenumber"
                class="input"
                v-model="fromData.tel"
                @focus="accountFocus = true"
                @blur="accountFocus = false"
              />
              <div class="icon-box" :class="{ 'icon-box-f': accountFocus }">
                <img :src="accountFocus ? accountImg2 : accountImg" class="icon" />
              </div>
            </div>
            <div class="item">
              <input
                :type="pwdText ? 'text' : 'password'"
                class="input"
                :placeholder="words.loginpassword"
                v-model="fromData.password"
                @focus="pwdFocus = true"
                @blur="pwdFocus = false"
              />
              <div class="icon-box" :class="{ 'icon-box-f': pwdFocus }">
                <img :src="pwdFocus ? pwdImg2 : pwdImg" class="icon" />
              </div>
              <img
                class="eye"
                :src="pwdText ? eyeImg2 : eyeImg"
                @click="pwdText ? (pwdText = false) : (pwdText = true)"
              />
            </div>
            <div class="outher-box">
              <Checkbox size="large" v-model="isSaveLogin">{{
                words.KeepLogin
              }}</Checkbox>
              <span class="passzh-btn" @click="$lfy.Jump.open('/pass-reteieve')">
                {{ words.forget }}
              </span>
            </div>
            <div class="login-btn hoverShow" @click="login">
              {{ words.login }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import loginMenu from "../../components/login-mode";
import QRCode from "qrcodejs2";
import config from "../../config";
import switchLang from "../../components/switch-lang";

export default {
  components: { loginMenu, switchLang },
  data() {
    return {
      background: require("../../assets/login_bg.png"),

      LoginMode: 1,
      PassBtn: require("../../assets/pass_btn.png"),
      QrcodeBtn: require("../../assets/qrcode_btn.png"),
      Logo: require("../../assets/logo-black.png"),
      // LoginCode: require("../../assets/1558079779.png"),
      AppCode: require("../../assets/app_code.png"),
      accountImg: require("../../assets/ic_login_account.png"),
      accountImg2: require("../../assets/ic_login_account_t.png"),
      pwdImg: require("../../assets/ic_login_pwd.png"),
      pwdImg2: require("../../assets/ic_login_pwd_t.png"),
      eyeImg: require("../../assets/ic_login_eye.png"),
      eyeImg2: require("../../assets/ic_login_eye_c.png"),
      accountFocus: false,
      pwdFocus: false,
      pwdText: false,
      isSaveLogin: false, //是否保持登录
      isRead: false,
      fromData: {
        tel: "",
        password: "",
        checkcode: "",
      },
      QrcodeSiteSn: "",

      SmsCodeData: {
        status: false,
        num: 60,
      },
      setInterval: {},
      carouselIndex: 0,
    };
  },
  mounted() {
    // console.log(this.$route);
    this.connectWebsocket();
    //判断是否有历史登录用户数据
    // let user =  localStorage.getItem('user');
    // if (user) {
    //   this.setUser(JSON.parse(user));
    //   this.$lfy.Jump.Redirect("/main");
    // }
  },
  methods: {
    ...mapActions(["UserMobileLogin", "setUser", "GetCode"]),
    SetLoginMOde(index) {
      if (index === 0) {
        this.connectWebsocket();
      }
      this.LoginMode = index;
    },
    qrccode() {
      document.getElementById("qrcode").innerHTML = "";

      /* let qrcodeData = {
        value: this.QrcodeSiteSn,
        type: 2,
      }; */
      let qrcodeData = config.loginQrcodeUrl + this.QrcodeSiteSn;
      let qrcode = new QRCode("qrcode", {
        width: 184,
        height: 184,
        text: qrcodeData, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
      });
      document.getElementById("qrcode").title = "";
    },
    connectWebsocket() {
      if ("WebSocket" in window) {
        this.QrcodeSiteSn = this.$lfy.com.generateMixed(32);
        this.websocket = new WebSocket(
          config.ws + "/websocket?site=" + this.QrcodeSiteSn
        );
        this.initWebSocket();
      } else {
        alert("当前浏览器不支持二维码登录，即将使用手机短信登录");
        this.SetLoginMOde(0);
      }
    },
    initWebSocket() {
      //连接错误
      this.websocket.onerror = this.setErrorMessage;
      // //连接成功
      this.websocket.onopen = this.setOnopenMessage;
      //收到消息的回调
      this.websocket.onmessage = this.setOnmessageMessage;
      //连接关闭的回调
      this.websocket.onclose = this.setOncloseMessage;
      //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      window.onbeforeunload = this.onbeforeunload;
    },
    setErrorMessage() {
      this.$Notice.error({
        title: "错误提醒",
        desc: "云知印扫码功能初始化失败，请联系管理员",
        duration: 0,
      });
      // this.qrccode();
    },
    setOnopenMessage() {
      console.log("WebSocket连接成功" + "   状态码：" + this.websocket.readyState);
    },
    setOnmessageMessage(event) {
      let data = JSON.parse(event.data);
      if (data.action === 200000) {
        this.qrccode();
      }
      if (data.action === 200001) {
        this.loginCallback(data.data);
      }
    },
    setOncloseMessage() {
      console.log("WebSocket连接关闭" + "   状态码：" + this.websocket.readyState);
    },
    onbeforeunload() {
      this.closeWebSocket();
    },
    //websocket发送消息
    send() {
      this.websocket.send(this.text);
      this.text = "";
    },
    closeWebSocket() {
      this.websocket.close();
    },
    loginCallback(data) {
      this.setUser(data);
      this.$lfy.Jump.Redirect("/main");
    },
    getSmsCode() {
      if (!this.fromData.tel) {
        this.$Message.error(this.words.Pleaseenterthephonenumber);
        return false;
      }
      if (!this.$lfy.check.checkMobile(this.fromData.tel)) {
        this.$Message.error(this.words.phonenumberError);
        return false;
      }
      if (this.SmsCodeData.status) return false;
      this.SmsCodeData.status = true;

      this.GetCode({ tel: this.fromData.tel, mode: 0 }).then((res) => {
        if (res.code !== 1) {
          this.$Message.error(res.msg);
          this.SmsCodeData.status = false;
          return false;
        }
        this.setInterval = setInterval(() => {
          this.SmsCodeData.num--;
          if (this.SmsCodeData.num < 1) {
            clearInterval(this.setInterval);
            this.setInterval = {};
            this.SmsCodeData = {
              num: 60,
              status: false,
            };
          }
        }, 1000);
      });
    },
    codeLogin() {
      if (!this.fromData.tel) {
        this.$Message.error(this.words.Pleaseenterthephonenumber);
        return false;
      }
      if (!this.$lfy.check.checkMobile(this.fromData.tel)) {
        this.$Message.error(this.words.phonenumberError);
        return false;
      }
      if (!this.fromData.checkcode || this.fromData.checkcode.length !== 6) {
        this.$Message.error(this.words.SMSverificationcodeerror);
        return false;
      }
      if (!this.isRead) {
        //判断是否阅读隐私声明
        this.$Message.error("请勾选隐私政策声明!");
        return false;
      }

      this.$Spin.show();
      this.UserMobileLogin(this.fromData).then((res) => {
        console.log(res);
        this.$Spin.hide();
        if (res.code !== 1) {
          this.$Message.error(res.msg);
          return false;
        }
        this.loginCallback(res.data);
      });
    },
    login() {
      if (!this.fromData.tel) {
        this.$Message.error(this.words.PleaseentertheMobile_Corporateemployeeaccount);
        return false;
      }

      if (!this.fromData.password) {
        this.$Message.error(this.words.PleaseenterthePassword);
        return false;
      }

      this.$Spin.show();
      this.UserMobileLogin(this.fromData).then((res) => {
        console.log(res);
        this.$Spin.hide();
        if (res.code !== 1) {
          this.$Message.error(res.msg);
          return false;
        }
        // if (this.isSaveLogin) {
        //   localStorage.setItem("user", JSON.stringify(res.data));
        // }
        this.loginCallback(res.data);
      });
    },
    LoginMenuChange(e) {
      if (e === 0) {
        const redirect_uri = encodeURIComponent(
          `https://${location.host}/#/login/wechat`
        );
        const url = `https://open.weixin.qq.com/connect/qrconnect?appid=${
          config.WechatOpen.AppId
        }&redirect_uri=${redirect_uri}&scope=snsapi_login&state=${new Date().getTime()}#wechat_redirect`;
        window.location.href = url;
      } else {
        const redirect_uri = encodeURIComponent(
          `https://${location.host}/#/login/dingtalk`
        );
        const url = `https://oapi.dingtalk.com/connect/qrconnect?appid=${
          config.Dingtalk.AppId
        }&response_type=code&scope=snsapi_login&state=${new Date().getTime()}&redirect_uri=${redirect_uri}`;
        // window.location.href = url;
        window.open(url);
      }
    },
  },
  computed: mapGetters({
    words: "words",
    user: "user",
  }),
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
